import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../utils/queryParams.js";

export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const FETCH_GOALS = "saga/FETCH_GOALS";
export const FETCH_GOALS_SUCCESS = "saga/FETCH_GOALS_SUCCESS";
export const FETCH_GOALS_FAILURE = "saga/FETCH_GOALS_FAILURE";
export const FETCH_TOP_GOALS = "saga/FETCH_TOP_GOALS";
export const FETCH_TOP_GOALS_SUCCESS = "saga/FETCH_TOP_GOALS_SUCCESS";
export const FETCH_TOP_GOALS_FAILURE = "saga/FETCH_TOP_GOALS_FAILURE";
export const FETCH_BOTTOM_GOALS = "saga/FETCH_BOTTOM_GOALS";
export const FETCH_BOTTOM_GOALS_SUCCESS = "saga/FETCH_BOTTOM_GOALS_SUCCESS";
export const FETCH_BOTTOM_GOALS_FAILURE = "saga/FETCH_BOTTOM_GOALS_FAILURE";
export const UPDATE_GOAL = "saga/UPDATE_GOAL";
export const UPDATE_GOAL_AS_VALUE = "saga/UPDATE_GOAL_AS_VALUE";
export const SET_TOP_GOALS_LOADING = "saga/SET_TOP_GOALS_LOADING";

// const axios = defaultNetworkService()
export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateGoal: createAction(UPDATE_GOAL),
  updateGoalAsValue: createAction(UPDATE_GOAL_AS_VALUE),
  fetchTopGoals: createAction(FETCH_TOP_GOALS),
  fetchBottomGoals: createAction(FETCH_BOTTOM_GOALS)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_GOAL, updateGoal);
  yield takeLatest(UPDATE_GOAL_AS_VALUE, updateGoalAsValue);
}

let date;

export function* getCurrentUserData(data) {
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });
  yield put({ type: SET_LOADING, payload: true });

  let newdate = new Date();
  let m = newdate.getMonth() + 1;
  let y = newdate.getFullYear();
  let d = newdate.getDate();
  let currentDate = y + "-" + m + "-" + d;

  date = currentDate;

  let allSagas = [fetchAllGoals(), fetchTopGoals(), fetchBottomGoals()];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchAllGoals() {
  let id = yield select(state => state.goals.currentUser.organization_id);
  let objectId = yield select(state => state.goals.currentUser.current_object_id);
  let locationId = yield select(state => state.goals.currentUser.current_location_id);
  let regionId = yield select(state => state.goals.currentUser.current_region_id);
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "goals" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_GOALS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GOALS_FAILURE, error });
  }
}

export function* updateGoal(data) {
  try {
    const goalsResponse = yield call(
      axios.put,
      queryParams.apiVersion + "goals/" + data.payload.id + "?goalIncrease=" + data.payload.value + "&active=" + data.payload.active
    );
    yield put({ type: SET_TOP_GOALS_LOADING, payload: true });
    let allSagas = [fetchAllGoals(), fetchTopGoals(), fetchBottomGoals()];
    yield all(allSagas);
    yield put({ type: SET_TOP_GOALS_LOADING, payload: false });
    return goalsResponse;
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GOALS_SUCCESS, error });
  }
}

export function* updateGoalAsValue(data) {
  try {
    const goalsResponse = yield call(
      axios.put,
      queryParams.apiVersion + "goals/" + data.payload.id + "?goalValue=" + data.payload.value + "&active=" + data.payload.active
    );
    yield put({ type: SET_TOP_GOALS_LOADING, payload: true });
    let allSagas = [fetchAllGoals(), fetchTopGoals(), fetchBottomGoals()];
    yield all(allSagas);
    yield put({ type: SET_TOP_GOALS_LOADING, payload: false });
    return goalsResponse;
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GOALS_SUCCESS, error });
  }
}

export function* fetchTopGoals() {
  let id = yield select(state => state.goals.currentUser.organization_id);
  let objectId = yield select(state => state.goals.currentUser.current_object_id);
  let locationId = yield select(state => state.goals.currentUser.current_location_id);
  let regionId = yield select(state => state.goals.currentUser.current_region_id);
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "goals/top_performing" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&limit=2"
    );
    yield put({ type: FETCH_TOP_GOALS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_TOP_GOALS_FAILURE, error });
  }
}

export function* fetchBottomGoals() {
  let id = yield select(state => state.goals.currentUser.organization_id);
  let objectId = yield select(state => state.goals.currentUser.current_object_id);
  let locationId = yield select(state => state.goals.currentUser.current_location_id);
  let regionId = yield select(state => state.goals.currentUser.current_region_id);
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "goals/least_performing" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date +
        "" +
        "&limit=2"
    );
    yield put({ type: FETCH_BOTTOM_GOALS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_BOTTOM_GOALS_FAILURE, error });
  }
}
